<template>

<section class="login-page">

    <!-- ========================= -->
    <!-- VOLVER -->
    <!-- ========================= -->

    <button
        type="button"
        class="back-button"
        @click="volver"
    >
        <v-icon
            small
            color="white"
        >
            mdi-arrow-left
        </v-icon>

        <span>
            Back
        </span>
    </button>


    <!-- ========================= -->
    <!-- LOGIN -->
    <!-- ========================= -->

    <div class="login-container">


        <!-- LOGO -->

        <router-link
            to="/"
            class="brand"
        >

            <img
                src="@/assets/images/logoPequenio.png"
                alt="Pole App"
                class="brand-logo"
            >

            <span>
                POLE APP
            </span>

        </router-link>


        <!-- CARD -->

        <div class="login-card">

            <div class="login-header">

                <span class="login-chip">
                    WELCOME BACK
                </span>

                <h1>
                    Sign in
                </h1>

                <p>
                    Save your favorite moves, track your
                    progress and continue your pole journey.
                </p>

            </div>


            <!-- ========================= -->
            <!-- ERROR GENERAL -->
            <!-- ========================= -->

            <v-alert
                v-if="mensajeError"
                type="error"
                text
                dismissible
                dark
                class="mb-5"
                @input="mensajeError = ''"
            >
                {{ mensajeError }}
            </v-alert>


            <!-- ========================= -->
            <!-- GOOGLE -->
            <!-- ========================= -->

            <button
                type="button"
                class="google-button"
                :disabled="cargando"
                @click="continuarConGoogle"
            >

                <v-icon
                    left
                    color="white"
                >
                    mdi-google
                </v-icon>

                <span>
                    Continue with Google
                </span>

            </button>


            <!-- ========================= -->
            <!-- SEPARADOR -->
            <!-- ========================= -->

            <div class="separator">

                <span></span>

                <p>
                    or continue with email
                </p>

                <span></span>

            </div>


            <!-- ========================= -->
            <!-- FORM -->
            <!-- ========================= -->

            <v-form
                ref="formLogin"
                v-model="formularioValido"
                lazy-validation
                @submit.prevent="iniciarSesion"
            >


                <!-- EMAIL -->

                <div class="field-group">

                    <label>
                        Email
                    </label>

                    <v-text-field
                        v-model.trim="form.email"
                        type="email"
                        autocomplete="email"
                        placeholder="you@email.com"
                        :rules="reglasEmail"
                        :error-messages="errores.email"
                        dark
                        outlined
                        dense
                        hide-details="auto"
                        class="login-field"
                        @input="limpiarError('email')"
                    />

                </div>


                <!-- PASSWORD -->

                <div class="field-group">

                    <div class="password-header">

                        <label>
                            Password
                        </label>

                        <router-link
                            to="/recuperar-password"
                            class="forgot-password"
                        >
                            Forgot password?
                        </router-link>

                    </div>


                    <v-text-field
                        v-model="form.password"
                        :type="
                            mostrarPassword
                                ? 'text'
                                : 'password'
                        "
                        :append-icon="
                            mostrarPassword
                                ? 'mdi-eye-off-outline'
                                : 'mdi-eye-outline'
                        "
                        autocomplete="current-password"
                        placeholder="Your password"
                        :rules="reglasPassword"
                        :error-messages="errores.password"
                        dark
                        outlined
                        dense
                        hide-details="auto"
                        class="login-field"
                        @click:append="
                            mostrarPassword =
                                !mostrarPassword
                        "
                        @input="limpiarError('password')"
                    />

                </div>


                <!-- SIGN IN -->

                <button
                    type="submit"
                    class="submit-button"
                    :disabled="cargando"
                >

                    <span v-if="!cargando">
                        Sign in
                    </span>

                    <v-progress-circular
                        v-else
                        indeterminate
                        size="20"
                        width="2"
                        color="black"
                    />

                </button>

            </v-form>


            <!-- ========================= -->
            <!-- REGISTRO -->
            <!-- ========================= -->

            <div class="register">

                <span>
                    New to Pole App?
                </span>

                <router-link
                    to="/registro"
                >
                    Create account
                </router-link>

            </div>

        </div>


        <!-- FOOTER -->

        <p class="login-footer">
            Your pole journey, all in one place.
        </p>

    </div>

</section>

</template>


<script>

import ClienteAuthService
    from "../service/ClienteAuthService";

export default {

    name: "ClienteLoginView",


    data() {

        return {

            formularioValido: false,

            cargando: false,

            mostrarPassword: false,

            mensajeError: "",

            errores: {},


            form: {

                email: "",

                password: ""

            },


            reglasEmail: [

                value =>
                    !!value ||
                    "Email is required.",

                value =>
                    /.+@.+\..+/.test(value) ||
                    "Enter a valid email."

            ],


            reglasPassword: [

                value =>
                    !!value ||
                    "Password is required."

            ]

        };

    },


    mounted() {

        this.redirigirSiYaEstaLogueado();

    },


    methods: {


        /* ========================= */
        /* VOLVER */
        /* ========================= */

        volver() {

            if (window.history.length > 1) {

                this.$router.go(-1);

                return;

            }

            this.$router.push("/");

        },


        /* ========================= */
        /* GOOGLE */
        /* ========================= */

        continuarConGoogle() {

            const redireccion =
                this.$route.query.redirect ||
                "/mypole')";


            localStorage.setItem(
                "google_redirect_after_login",
                redireccion
            );


            ClienteAuthService.loginConGoogle();

        },


        /* ========================= */
        /* YA LOGUEADA */
        /* ========================= */

        redirigirSiYaEstaLogueado() {

            const token =
                localStorage.getItem(
                    "cliente_token"
                );


            if (token) {

                this.$router.replace({
                    name: "cliente-perfil"
                });

            }

        },


        /* ========================= */
        /* LIMPIAR ERROR */
        /* ========================= */

        limpiarError(campo) {

            if (this.errores[campo]) {

                this.$delete(
                    this.errores,
                    campo
                );

            }

            this.mensajeError = "";

        },


        /* ========================= */
        /* LOGIN EMAIL / PASSWORD */
        /* ========================= */

        async iniciarSesion() {

            this.mensajeError = "";

            this.errores = {};


            const esValido =
                this.$refs.formLogin.validate();


            if (!esValido) {

                return;

            }


            this.cargando = true;


            try {

                const respuesta =
                    await ClienteAuthService.login({

                        email:
                            this.form.email
                                .trim()
                                .toLowerCase(),

                        password:
                            this.form.password

                    });


                const {
                    access_token,
                    cliente
                } = respuesta.data;


                if (
                    !access_token ||
                    !cliente
                ) {

                    throw new Error(
                        "Invalid server response."
                    );

                }


                localStorage.setItem(
                    "cliente_token",
                    access_token
                );


                localStorage.setItem(
                    "cliente_data",
                    JSON.stringify(cliente)
                );


                /*
                 * Si vino desde una página protegida,
                 * volvemos a esa página.
                 */

                const redireccion =
                    this.$route.query.redirect;


                if (
                    redireccion &&
                    redireccion.startsWith("/")
                ) {

                    this.$router.replace(
                        redireccion
                    );

                    return;

                }


                /*
                 * Login normal desde navbar:
                 * va a My Pole / Mi Cuenta.
                 */

                this.$router.replace({
                    name: "cliente-perfil"
                });


            } catch (error) {

                console.error(
                    "ERROR LOGIN:",
                    error
                );


                if (
                    error.response &&
                    error.response.status === 422
                ) {

                    this.errores =
                        error.response.data.errors ||
                        {};

                }


                this.mensajeError =
                    error.response?.data?.message ||
                    "We couldn't sign you in. Check your email and password.";


            } finally {

                this.cargando = false;

            }

        }

    }

};

</script>


<style scoped>

/* ===================================== */
/* PAGE */
/* ===================================== */

.login-page {

    min-height: 100svh;

    position: relative;

    display: flex;

    align-items: center;

    justify-content: center;

    padding: 3rem 1.5rem;

    background:
        linear-gradient(
            rgba(0,0,0,.72),
            rgba(0,0,0,.94)
        ),
        url("@/assets/images/PoleDancerBackgroundBanner.jpg")
        center center / cover
        no-repeat;

}


/* ===================================== */
/* BACK */
/* ===================================== */

.back-button {

    position: absolute;

    top: 1.5rem;

    left: 1.5rem;

    display: flex;

    align-items: center;

    gap: .45rem;

    padding: .5rem .75rem;

    border: 0;

    background: transparent;

    color: #BDBDBD;

    font-size: .85rem;

    cursor: pointer;

    transition: .2s;

}

.back-button:hover {

    color: white;

}


/* ===================================== */
/* CONTAINER */
/* ===================================== */

.login-container {

    width: 100%;

    max-width: 430px;

}


/* ===================================== */
/* BRAND */
/* ===================================== */

.brand {

    display: flex;

    align-items: center;

    justify-content: center;

    gap: .7rem;

    margin-bottom: 1.25rem;

    color: white;

    text-decoration: none;

    font-size: .8rem;

    font-weight: 800;

    letter-spacing: .12em;

}

.brand-logo {

    width: 38px;

    height: 38px;

    object-fit: contain;

}


/* ===================================== */
/* CARD */
/* ===================================== */

.login-card {

    padding: 2.2rem;

    border-radius: 24px;

    border:
        1px solid
        rgba(255,255,255,.10);

    background:
        rgba(15,15,15,.94);

    box-shadow:
        0 30px 80px
        rgba(0,0,0,.50);

    backdrop-filter: blur(18px);

}


/* ===================================== */
/* HEADER */
/* ===================================== */

.login-header {

    margin-bottom: 1.6rem;

}

.login-chip {

    display: inline-block;

    margin-bottom: .65rem;

    color: #8DB8FF;

    font-size: .7rem;

    font-weight: 800;

    letter-spacing: .12em;

}

.login-header h1 {

    margin: 0 0 .6rem;

    color: white;

    font-size: 2.5rem;

    font-weight: 900;

    line-height: 1.05;

}

.login-header p {

    margin: 0;

    color: #AFAFAF;

    font-size: .9rem;

    line-height: 1.6;

}


/* ===================================== */
/* GOOGLE */
/* ===================================== */

.google-button {

    width: 100%;

    height: 48px;

    display: flex;

    align-items: center;

    justify-content: center;

    gap: .35rem;

    border:
        1px solid
        rgba(255,255,255,.18);

    border-radius: 999px;

    background: #1B1B1B;

    color: white;

    font-size: .9rem;

    font-weight: 700;

    cursor: pointer;

    transition: .2s;

}

.google-button:hover {

    background: #252525;

    border-color:
        rgba(255,255,255,.35);

}

.google-button:disabled {

    opacity: .55;

    cursor: default;

}


/* ===================================== */
/* SEPARATOR */
/* ===================================== */

.separator {

    display: flex;

    align-items: center;

    gap: .8rem;

    margin: 1.4rem 0;

}

.separator span {

    flex: 1;

    height: 1px;

    background:
        rgba(255,255,255,.10);

}

.separator p {

    margin: 0;

    color: #707070;

    font-size: .72rem;

    white-space: nowrap;

}


/* ===================================== */
/* FORM */
/* ===================================== */

.field-group {

    margin-bottom: 1.15rem;

}

.field-group label {

    display: block;

    margin-bottom: .45rem;

    color: #D8D8D8;

    font-size: .78rem;

    font-weight: 600;

}


/* Vuetify field */

.login-field::v-deep .v-input__slot {

    min-height: 46px !important;

    border-radius: 12px !important;

    background:
        rgba(255,255,255,.035) !important;

}


/* ===================================== */
/* PASSWORD HEADER */
/* ===================================== */

.password-header {

    display: flex;

    align-items: center;

    justify-content: space-between;

}

.password-header label {

    margin-bottom: .45rem;

}

.forgot-password {

    margin-bottom: .45rem;

    color: #8DB8FF;

    text-decoration: none;

    font-size: .73rem;

    transition: .2s;

}

.forgot-password:hover {

    color: white;

}


/* ===================================== */
/* SUBMIT */
/* ===================================== */

.submit-button {

    width: 100%;

    height: 48px;

    display: flex;

    align-items: center;

    justify-content: center;

    margin-top: .3rem;

    border: 0;

    border-radius: 999px;

    background: white;

    color: #101010;

    font-size: .9rem;

    font-weight: 800;

    cursor: pointer;

    transition: .2s;

}

.submit-button:hover {

    transform: translateY(-1px);

    background: #EEEEEE;

}

.submit-button:disabled {

    opacity: .6;

    cursor: default;

}


/* ===================================== */
/* REGISTER */
/* ===================================== */

.register {

    display: flex;

    justify-content: center;

    gap: .4rem;

    margin-top: 1.5rem;

    color: #858585;

    font-size: .8rem;

}

.register a {

    color: white;

    text-decoration: none;

    font-weight: 700;

}

.register a:hover {

    text-decoration: underline;

}


/* ===================================== */
/* FOOTER */
/* ===================================== */

.login-footer {

    margin:

        1.2rem 0
        0;

    color: #666;

    text-align: center;

    font-size: .72rem;

}


/* ===================================== */
/* MOBILE */
/* ===================================== */

@media(max-width:600px) {

    .login-page {

        align-items: flex-start;

        padding:
            4.7rem 1rem
            2rem;

    }


    .back-button {

        top: .9rem;

        left: .7rem;

    }


    .brand {

        margin-bottom: 1rem;

    }


    .brand-logo {

        width: 34px;

        height: 34px;

    }


    .login-card {

        padding:
            1.6rem
            1.25rem;

        border-radius: 20px;

    }


    .login-header {

        margin-bottom: 1.3rem;

    }


    .login-header h1 {

        font-size: 2rem;

    }


    .login-header p {

        font-size: .83rem;

    }


    .google-button {

        height: 46px;

    }


    .submit-button {

        height: 46px;

    }

}

</style>